<template>
  <div class="medic-input">
    <v-select
      :options="options"
      v-model="selected"
      :reduce="cita => cita"
      label="name"
      @search="UpdateMedics"
      @input="setSelected"
    >
      <template slot="no-options">Escribe para buscar médicos</template>
      <template slot="option" slot-scope="option">
        <div class="d-center">{{ option.name }}</div>
      </template>
    </v-select>
  </div>
</template>

<script>
// import MedicsManager from "../managers/medicsManager";
import vSelect from "vue-select";
import gun from "../managers/gun";
export default {
  components: {
    vSelect
  },
  props: {
    user: String,
    pub: String
  },
  data() {
    return {
      searchString: "Buscar paciente",
      options: [],
      selected: ""
    };
  },
  methods: {
    async UpdateMedics(search, loading) {
      loading(true);
      let options = []
      var promise = gun
        .get("main-user-list")
        .map()
        .once((data) => {
 
          console.log(data)
            if(data != null && !data.medic)
            options.push(data)
            // gun
            //   .user(data.patient)
            //   .get("profile")
            //   .on(async profile => {
            //     console.log(profile)
            //     var date = new Date(data.date);
            //     cita.name = profile.name;
            //     cita.date = date.toLocaleString();
            //     cita.medic = data.medic
                
            //     cita.patient = profile.wallet
            //     cita.pub = data.patient
            //      options.push(cita);
            //   });
         
          }
        );
        await promise
          this.options = options;
        loading(false)
    },
    setSelected() {
      console.log("selected")
        console.log(this.selected)
      this.$emit("update:wallet", this.selected.wallet);
      this.$emit("update:pub",this.selected.pub)
    }
  },
  created() {
    // this.UpdateMedics();
  }
};
</script>

<style lang="scss" scoped>
img {
  height: auto;
  max-width: 2.5rem;
  margin-right: 1rem;
}

.d-center {
  display: flex;
  align-items: center;
}

.selected img {
  width: auto;
  max-height: 23px;
  margin-right: 0.5rem;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}
</style>